<template>
  <ElDialog
    v-if="!displayAsSection"
    class="modal"
    :visible.sync="showModal"
    :width="modalWidth"
  >
    <h2 class="modal__title">
      {{ title }}
    </h2>
    <div class="modal__body">
      <p class="modal__text">
        {{ text }}
      </p>

      <ElForm
        class="form"
        ref="propertyFormRef"
        :rules="rules"
        :model="requestCallForm"
        @submit.native.prevent="submitHandler"

      >
        <div class="form__item">
          <ElFormItem
            class="form__col"
            prop="fio"
          >
            <ElInput
              v-model="requestCallForm.fio"
              placeholder="ФИО"
            >
              <template #prefix>
                ФИО
              </template>
            </ElInput>
          </ElFormItem>
        </div>





        <div class="form__item form__item--col">
          <ElFormItem
            class="form__col form__col--half"
            prop="phone"
          >
            <ElInput
              v-model="requestCallForm.phone"
              placeholder="Номер телефона"
              v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
            >
              <template #prefix>
                Телефон
              </template>
            </ElInput>
          </ElFormItem>

          <ElFormItem
            class="form__col form__col--half"
            prop="email"
          >
            <ElInput
              v-model="requestCallForm.email"
              type="email"
              placeholder="E-mail">
              <template #prefix>
                E-mail
              </template>
            </ElInput>
          </ElFormItem>
        </div>

        <ElFormItem prop="agree" class="form__item">
          <ElCheckbox v-model="requestCallForm.agree">
            Я даю <a
              href="/upload/rules/Приложение 9_Согласие для покупки полиса на сайте.pdf"
              target="_blank"
            >согласие</a> на обработку персональных данных в соответствии с <a
              href="/company/privacy/"
              target="_blank"
            >политикой обработки персональных данных</a>
         
          </ElCheckbox>
        </ElFormItem>
      </ElForm>
    </div>
    <div class="modal__submit-buttons">
          <BaseButton
            class=""
            :text="buttonText"
            size="large"
            native-type="submit"
            :disabled="isSubmitting"
            @click.native="manualSubmitTrigger('modal')"
          />
        </div>

  </ElDialog>
  <div v-else class="feedback-form-section"> 
    <h2 v-if="title" class="feedback-form__title">{{ title }}</h2>
    <p v-if="text" class="feedback-form__text">{{ text }}</p>

    <ElForm
      class="form"
      ref="propertyFormRef"
      :rules="rules"
      :model="requestCallForm"
      @submit.native.prevent="submitHandler"
    >
      <div class="form__item">
        <ElFormItem
          class="form__col"
          prop="fio"
        >
          <ElInput
            v-model="requestCallForm.fio"
            placeholder="ФИО"
          >
            <template #prefix>
              ФИО
            </template>
          </ElInput>
        </ElFormItem>
      </div>

      <div class="form__item form__item--col">
        <ElFormItem
          class="form__col form__col--half"
          prop="phone"
        >
          <ElInput
            v-model="requestCallForm.phone"
            placeholder="Номер телефона"
            v-mask="{regex: '^\\+7 \\([0-9]${3}\\) [0-9]${3} [0-9]${2}-[0-9]${2}'}"
          >
            <template #prefix>
              Телефон
            </template>
          </ElInput>
        </ElFormItem>

        <ElFormItem
          class="form__col form__col--half"
          prop="email"
        >
          <ElInput
            v-model="requestCallForm.email"
            type="email"
            placeholder="E-mail">
            <template #prefix>
              E-mail
            </template>
          </ElInput>
        </ElFormItem>
      </div>
      <div class="form__item">
        <ElFormItem prop="personalDataAgreement" class="form__col form__col--agreement">
          <ElCheckbox v-model="requestCallForm.personalDataAgreement">
            <span class="agreement-text">
              Отправляя форму, я соглашаюсь с политикой
              <a href="/company/privacy/" target="_blank" class="agreement-link">обработки персональных данных</a>
            </span>
          </ElCheckbox>
        </ElFormItem>
      </div>

      <div class="feedback-form__submit-buttons"> 
        <BaseButton
          :text="buttonText"
          size="large"
          native-type="submit"
          :disabled="isSubmitting"
          @click.native="manualSubmitTrigger('section')"
        />
      </div>
    </ElForm>
  </div>
</template>

<script>
import { matchesEmailRegex, numbersLengthFromString } from '@/utils/string-helpers';
import { validationHandler } from '@/utils/validation';
import { PHONE_LENGTH } from '@/consts';
import modal from '@/mixins/modal';
import BaseButton from '@/components/ui/BaseButton';

export default {
  name: 'ModalRequestCall',
  components: {
    BaseButton
  },
  mixins: [modal],
  props: {
       
    visible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: ''
    },
    text: {
      type: String,
      default: ''
    },
    displayAsSection: {
      type: Boolean,
      default: false,
    },
    buttonText: {
      type: String,
      default: 'Заказать', 
    },
    isSubmitting: {
      type: Boolean,
      default: false,
    },
    formData: {
      required: false
    }
  },
  data() {
    return {
      rules: {
        fio: [
          { required: true, message: 'Поле ФИО обязательно для заполнения', trigger: 'blur' },
        ],
        phone: [
          { required: true, message: 'Поле номер телефона обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.phoneLengthIsValid, `Номер телефона должен содержать ${PHONE_LENGTH} символов`, resolve),
            trigger: 'blur'
          },
        ],
        email: [
          { required: true, message: 'Поле e-mail обязательно для заполнения', trigger: 'blur' },
          {
            validator: (rule, val, resolve) => validationHandler(this.emailFormatIsValid, 'Неверный формат электронной почты!', resolve),
            trigger: 'blur'
          },
        ],
        agree: [
          
          {
            validator: (rule, value, callback) => {
              if (value === true) { 
                callback();
              } else {
                callback(new Error('Необходимо дать согласие на обработку персональных данных')); 
              }
            },
            trigger: 'change'
          }
        ],
        personalDataAgreement: [
          { required: true, message: 'Необходимо дать согласие на обработку персональных данных', trigger: 'change' },
          { validator: (rule, value, callback) => {
              if (value) { callback(); } else { callback(new Error('Необходимо дать согласие')); }
            }, trigger: 'change' }
        ]
      },
      requestCallForm: {
        fio: '',
        phone: '',
        email: '',
        agree: false,
        personalDataAgreement: false,
      }
    };
  },
  computed: {
    emailFormatIsValid() {
      return matchesEmailRegex(this.requestCallForm.email);
    },
    phoneLengthIsValid() {
      return numbersLengthFromString(this.requestCallForm.phone) >= PHONE_LENGTH
    },
  },
  methods: {
    manualSubmitTrigger(source) {
      this.submitHandler();
    },
    submitHandler() {

      const currentFormRef = this.$refs.propertyFormRef;

      if (!currentFormRef || typeof currentFormRef.validate !== 'function') {
        return;
      }

      currentFormRef.validate((valid, fields) => {

        if (valid) {

          this.$emit('request-call-submit', { ...this.requestCallForm }); // Отправляем копию объекта
        }
      });
    },
    resetFormFields() {
      this.requestCallForm.fio = '';
      this.requestCallForm.phone = '';
      this.requestCallForm.email = '';
      this.requestCallForm.personalDataAgreement = false;
    }
  },
  beforeUpdate() {
    let fullName = '';

    if (
      !!this.formData
      && !!this.formData?.data?.lastName
    ) {
      fullName = this.formData.data.lastName
    }

    if (
      !!this.formData
      && !!this.formData?.data?.name
    ) {
      fullName += (' ' + this.formData.data.name)
    }

    if (
      !!this.formData
      && !!this.formData?.data?.secondName
    ) {
      fullName += (' ' + this.formData.data.secondName)
    }

    if (
      !this.requestCallForm.fio
      && !!fullName
    ) {
      this.requestCallForm.fio = fullName;
    }

    if (
      !this.requestCallForm.phone
      && !!this.formData?.data?.phone
    ) {
      this.requestCallForm.phone = this.formData.data.phone;
    }

    if (
      !this.requestCallForm.email
      && !!this.formData?.data?.email
    ) {
      this.requestCallForm.email = this.formData.data.email;
    }
    
  }
}
</script>

<style lang="scss" scoped>
.feedback-form__submit-buttons .button {
  width: calc(50% - 10px);
}
.modal {
  &__text {
    &:not(:last-child) {
      margin-bottom: rem(32);
    }
  }

  &__title { 
    margin-bottom: 20px;
    font-size: 24px; 
  }

  &__text { 
    margin-bottom: 30px;
    color: #555; 
  }
}


.feedback-form-section {
}

.feedback-form__title {
  margin-bottom: 20px;
  font-size: 20px;
}

.feedback-form__text {
  font-size: 16px;
  margin-bottom: 30px;
  color: #555;
}

.form__item {
  display: flex;
  margin-bottom: 20px;
}

.form__item--col {
  gap: 20px;
}

.form__col {
  flex: 1;
}

.form__col--half {
  flex-basis: calc(50% - 10px);
}

.form__col--agreement {
  :deep(.el-form-item__content) {
    line-height: normal; 
  }
}

.agreement-text {
  font-size: rem(12);
  color: #555;
  line-height: 1.4;
  display: inline; 
}

.agreement-link {
  color: $bondi-blue; 
  text-decoration: underline;
  &:hover {
    text-decoration: none;
  }
}
</style>
